import React from 'react';
import { ColorModeButton } from './ui/color-mode';

export const DarkModeSwitch = () => <ColorModeButton variant='ghost' color='accent-alt' />;
